module.exports = "https://static.wmbcdn.com/uniweb/images/c69e56b05172a6d178aee01519fa6698.svg";